import { ToggleButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { useBoldToggle } from 'common/Prose/Toolbar/hooks/useBoldToggle'
import { Bold } from 'blaze-ui/icons'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { observer } from 'mobx-react-lite'
import { PressEvent } from '@react-types/shared'

const Bold24 = () => <Bold size={24} />

export const BoldButton = observer(() => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useBoldToggle(view)

  const onPress = (e: PressEvent) => {
    handleClick(e)
    view.dispatch(view.state.tr.scrollIntoView())
  }

  return (
    <ToggleButton
      preventFocusOnPress
      on={active}
      onPress={onPress}
      isDisabled={disabled}
      icon={Bold24}
      aria-label="Bold"
    />
  )
})
